// @flow

import { Map } from 'immutable'

export const fuzzySearch = (substr: string, string: string) => {
  const arr = substr.toLowerCase().split('').reverse()
  let tmp = arr.pop()

  string
    .toLowerCase()
    .split('')
    .forEach(elem => {
      if (elem === tmp) {
        tmp = arr.pop()
      }
    })

  return arr.length === 0 && typeof tmp === 'undefined'
}

export const gallerySearch = (images, filterBy, lazyLoaded) => {
  const result =
    filterBy && filterBy.length >= 1
      ? images
          .filter((image: Map<string, any>) => {
            const usagePlaces = image.get('usagePlaces')
            const fileName = image.get('fileName')
            const placesToSearch = `${fileName}__${usagePlaces}`.toLowerCase()
            const filtersByLower = filterBy.toLowerCase().split(' ')
            return filtersByLower.every((by: string) => {
              return placesToSearch.includes(by)
            })
          })
          .slice(0, lazyLoaded)
      : images.slice(0, lazyLoaded)
  return result
}
